import { render, staticRenderFns } from "./Tendency.vue?vue&type=template&id=21c4f566&"
import script from "./Tendency.vue?vue&type=script&lang=js&"
export * from "./Tendency.vue?vue&type=script&lang=js&"
import style0 from "./Tendency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports